export const deleteServiceSuccessString = 'Successfully deleted service!';
export const deleteServiceModalTitle = 'Delete this service?';
export const deleteServiceModalDescription = 'This cannot be undone!';
export const deleteServiceModalKeepButton = 'keep';
export const deleteServiceModalDeleteButton = 'delete';
export const deleteServiceButton = 'delete this service';
export const deleteServiceButtonLabel = 'Delete';
